var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashDarkRedTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7455_23782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.334 4.00065H14.6673V5.33398H13.334V14.0007C13.334 14.1775 13.2637 14.347 13.1387 14.4721C13.0137 14.5971 12.8441 14.6673 12.6673 14.6673H3.33398C3.15717 14.6673 2.9876 14.5971 2.86258 14.4721C2.73756 14.347 2.66732 14.1775 2.66732 14.0007V5.33398H1.33398V4.00065H4.66732V2.00065C4.66732 1.82384 4.73756 1.65427 4.86258 1.52925C4.9876 1.40422 5.15717 1.33398 5.33398 1.33398H10.6673C10.8441 1.33398 11.0137 1.40422 11.1387 1.52925C11.2637 1.65427 11.334 1.82384 11.334 2.00065V4.00065ZM6.00065 7.33398V11.334H7.33398V7.33398H6.00065ZM8.66732 7.33398V11.334H10.0007V7.33398H8.66732ZM6.00065 2.66732V4.00065H10.0007V2.66732H6.00065Z",
    fill: "#A13E3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7455_23782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDarkRedTwo);
export default __webpack_public_path__ + "static/media/trashDarkRedTwo.1ea5b3a815ba1ad0eeb5da64ded28e61.svg";
export { ForwardRef as ReactComponent };